import { ChangeDetectionStrategy, Component, computed, signal, inject } from '@angular/core';
import { ModalRef } from '~/app/shared/services/modal/modal-ref';
import { TranslocoService } from '@jsverse/transloco';
import { SpinnerComponent } from '~/app/shared/components/elements/loaders/spinner/spinner.component';
import { Observable } from 'rxjs';
import { ModalConfirmationButton } from '~/app/shared/modals/v2/modal-confirmation/modal-confirmation.component';
@Component({
    selector: 'eb-modal-processing',
    templateUrl: './modal-processing.component.html',
    styleUrls: ['./modal-processing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SpinnerComponent,
    ]
})
export class ModalProcessingComponent {
    private translocoService = inject(TranslocoService);
    private ref = inject<ModalRef<boolean, {
    title?: string;
    message?: string;
    entity?: 'portfolio' | 'proposal' | 'simulation';
    buttons?: ModalConfirmationButton[];
    onConfirmation: () => Observable<any>;
}>>(ModalRef);

    public entity = signal<'portfolio' | 'proposal' | 'simulation'>('portfolio');
    public buttons: ModalConfirmationButton[] = [
        {
            title: this.translocoService.translate('common.cancel'),
            callback: () => {
                this.ref.close(false);
            },
            color: 'secondary',
            outline: true,
            buttonPriority: 'secondary'
        },
    ];

    get vm() {
        return this.viewModel();
    }

    protected viewModel = computed(() => {
        return {
            entity: this.entity(),
        };
    });
    constructor() {
        if (this.ref.data.buttons) {
            this.buttons = this.ref.data.buttons;
        }
        if (this.ref.data.entity) {
            this.entity.set(this.ref.data.entity ?? 'portfolio');
        }
    }

    public close(answer: boolean): void {
        this.ref.close(answer);
    }

}
